export default defineNuxtPlugin(() => {
  return {
    provide: {
      pluralize: (
        string_identifier_0: string,
        string_identifier_1: string,
        string_identifier_many: string,
        number: number
      ) => {
        const { $t } = useNuxtApp();
        if (number == 0) {
          return $t(string_identifier_0, [{ id: 'number', value: number }]);
        } else if (number == 1) {
          return $t(string_identifier_1, [{ id: 'number', value: number }]);
        } else {
          return $t(string_identifier_many, [{ id: 'number', value: number }]);
        }
      },
    },
  };
});
